import { SupportedWalletType } from './rateplan'

export type Currency =
  | 'IRR'
  | 'USD'
  | 'EUR'
  | 'GBP'
  | 'AED'
  | 'TRY'
  | 'CNY'
  | 'RUB'
  | 'IQD'
  | ''
  | undefined

export const CurrencyList = [
  {
    Label: {
      EN: 'IRR',
      FA: 'ریال'
    },
    Value: 'IRR'
  },
  {
    Label: {
      EN: 'USD',
      EN_KEY: '$',
      FA: 'دلار'
    },
    Value: 'USD'
  },
  {
    Label: {
      EN: 'EUR',
      EN_KEY: '€',
      FA: 'یورو'
    },
    Value: 'EUR'
  },
  {
    Label: {
      EN: 'GBP',
      FA: 'پوند'
    },
    Value: 'GBP'
  },
  {
    Label: {
      EN: 'AED',
      FA: 'درهم امارات'
    },
    Value: 'AED'
  },
  {
    Label: {
      EN: 'TRY',
      FA: 'لیره ترک'
    },
    Value: 'TRY'
  },
  {
    Label: {
      EN: 'CNY',
      FA: 'یوان چین'
    },
    Value: 'CNY'
  },
  {
    Label: {
      EN: 'RUB',
      FA: 'روبل روسیه'
    },
    Value: 'RUB'
  },
  {
    Label: {
      EN: 'IQD',
      FA: 'دینار عراق'
    },
    Value: 'IQD'
  }
]

export const SupportedWalletTypeInitValues: SupportedWalletType[] = [
  {
    currency: 'IRR',
    walletTypes: ['ProviderCredit'],
    isSelected: true
  },
  { currency: 'USD', walletTypes: [], isSelected: false },
  { currency: 'EUR', walletTypes: [], isSelected: false },
  { currency: 'GBP', walletTypes: [], isSelected: false },
  { currency: 'AED', walletTypes: [], isSelected: false },
  { currency: 'TRY', walletTypes: [], isSelected: false },
  { currency: 'CNY', walletTypes: [], isSelected: false },
  { currency: 'RUB', walletTypes: [], isSelected: false },
  { currency: 'IQD', walletTypes: [], isSelected: false }
]
